import axios from 'axios';
import Vue from 'vue'

export default {
    getInvoices (page, pageSize, supplierId,customerId,status) {
        return axios.get('/api/invoices/list', { params: {page: page, pageSize: pageSize, supplierId:supplierId,customerId:customerId,status:status} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    // saveInvoice(invoice,fd){
    //     return axios.post('/api/invoices/save'+ '/'+invoice.customer.id+'/'+encodeURIComponent(invoice.name)+'/'+invoice.date+'/'+invoice.total+'/'+invoice.type, 
    //     fd,{headers: {'Content-Type': 'multipart/form-data' }})
    //     .then(response => {
            
    //         if (response && response.data) {
    //             Vue.prototype.$snotify.success("Facture enregistrée avec succès");
    //             return response.data;
    //         } 
    //     })
    //     .catch(error => {Vue.prototype.$snotify.error(error);})

    // },

    saveInvoice(fd){
        return axios.post('/api/invoices/save', fd)
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Facture enregistrée avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    editInvoice(invoice){
        return axios.post('/api/invoices/edit', invoice)
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Facture enregistrée avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    removeInvoice(invoice){
        return axios.post("/api/invoices/remove/",invoice)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Facture supprimée avec succès");
                 return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveInvoiceFilePDF(formData,id){
        return axios.post("/api/invoices/invoiceFile/"+id, formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success('Fichier PDF importé avec succès');
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveWithholdingFilePDF(formData,id){
        return axios.post("/api/invoices/withholding/"+id, formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success('Fichier PDF importé avec succès');
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteWithholdingFile(id){
        return axios.post("/api/invoices/withholding/remove/"+id)
        .then(response => { 
            if (response && response.data) {
                Vue.prototype.$snotify.success("Retenue à la source supprimée avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteInvoice (id) {
        return axios.post('/api/invoices/remove', {id : id})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Facture supprimée avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    downloadFile(name){
        axios({
            url:'/api/file/get/'+ name,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.pdf');
            document.body.appendChild(link);
            link.click();
          });
    },

    getInvoicesCount(){
        return axios.get('/api/invoices/count/')
        .then(response => {
            if (response && response.data)  return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findInvoice(id){
        return axios.get('/api/invoices/invoice/' + id)
        .then(response => {
            if (response && response.data)  return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getWithHolding(invoiceId){
        axios({
            url:'/api/invoices/withHolding/'+ invoiceId,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
           link.href = url;
            link.setAttribute('download', 'Retenue-Source.pdf');
            document.body.appendChild(link);
            link.click();
          }).catch(() => {
              Vue.prototype.$snotify.error("La retenue à la source ne peut pas être générée pour cette facture");});
    },

    downloadWithHolding (id) {
        return axios.get('/api/invoices/withHolding/check/'+id)
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}